export enum FleetUpdateActionType {
  ADD,
  REMOVE,
}
